import gql from 'graphql-tag';

import fileFragment from '../files/file-fragment';

const categoryFragment = gql`
    fragment CategoryFragment on Category {
        _id
        __typename
        name
        description
        isPublished
        metaKeyWords
        language
        metaDescription
        metaTitle
        alias
        image {
            ...FileFragment
        }
        thumbnail {
            ...FileFragment
        }
    }
    ${fileFragment}
`;

export default categoryFragment;
